import { render, staticRenderFns } from "./WincareOldAdminList.vue?vue&type=template&id=eecf6e42"
import script from "./WincareOldAdminList.vue?vue&type=script&lang=js"
export * from "./WincareOldAdminList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports